<script>
import EmployeeAPI from "@/services/employee/employeeAPI";
import CopassConformationActAPI from "@/services/standards/copassConformationActAPI";
import CheckModal from "@/components/CheckModal";
import Swal from "sweetalert2";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  props: {
    companyID: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CheckModal,
  },
  data() {
    return {
      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "A",
      employees: [],
      nit: this.$store.getters["company/getCompany"].nit || null,
      employee: null,
      copassDate: null,
      file: null,
      fileURL: null,
      lastID: 1,
      submitted: false,
      copassFile: "This is a file link",
      rows: [],
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      dateFrom: null,
      dateTo: null,
      loading1: true,
      click: 0,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 6,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha actualizado el estado del ítem!",
            type: "error",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          console.log(error);
          setTimeout(() => window.location.reload(), 2000)
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getEmployees() {
      EmployeeAPI.getAll(this.companyID)
        .then((response) => {
          let allEmployees = response.employee || [];
          let employees = [];
          if (allEmployees.length > 0) {
            employees = allEmployees.filter(
              (employee) =>
                (employee.contract_type_id === 1 ||
                  employee.contract_type_id === 3) &&
                employee.is_active === 1
            );
          }
          this.employees = employees;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * Get file name with format.
     * @param {String} file Is the name the file.
     * @return {String} The new format the file name.
     */
    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.6/vigia/${this.lastID}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.6/vigia/${this.lastID}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.fileURL = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true;
      try {
        const res = await CopassConformationActAPI.createCopassConformationAct({
          date: this.copassDate,
          position: "Vigía de salud",
          employee_id: this.employee,
          vigencia_desde: this.dateFrom,
          vigencia_hasta: this.dateTo,
        });
        await newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 6, status: "Pendiente" });
        this.sendNotification(5, 6, true);
        const id = res && res.id;
        Swal.fire({ title: "¡Éxito!", text: "¡Vigía registrado! Continúa para descargar/firmar el acta.", icon: "success", timer: 2000, showConfirmButton: false });
        if (id) {
          this.$router.push({ path: `/forms/estandares/${this.companyID}/acta-conformacion1.1.6/${id}` });
        } else {
          setTimeout(() => window.location.reload(), 2000);
        }
      } catch (error) {
        console.log(error);
        this.loading1 = false;
        Swal.fire({ title: "¡Error!", text: "¡No se ha podido registrar!", icon: "error", confirmButtonClass: "btn btn-confirm mt-2" });
      }
    },

    getConformationActs() {
      CopassConformationActAPI.getConformationActCompany(this.companyID)
        .then((response) => {
          let list = response.data.data;
          this.rows = list || [];
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log("This is an error on getConformationActs", error);
        });
    },

    // Descarga el acta BRANDED (logo + control + firma del encargado) generada por la plataforma.
    downloadActa(id) {
      if (!id) return;
      window.open(CopassConformationActAPI.pdfUrl(id), "_blank");
    },
  },
  mounted() {
    this.getEmployees();
    this.getConformationActs();
    this.getStatusItem();
    this.getItemData();
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12" v-if="!loading1">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <CheckModal>
                <p class="text-justify">
                  La empresa cuenta, de acuerdo con el número de trabajadores con:
                </p>
                <p class="text-justify">
                  <b>Vigía en Seguridad y Salud en el Trabajo</b> para empresas de menos de diez (10) de trabajadores.
                </p>
                <p class="text-justify">
                  <b>Comité Paritario en Seguridad y Salud en el Trabajo COPASST</b> para empresas de diez (10) o más
                  trabajadores
                </p>
                <br />
                La empresa debe garantizar que se lleve el proceso de
                convocatoria, inscripción, votaciones y designación de los
                representantes al comité y almacenar las actas. Mensualmente,
                los integrantes deben realizar una reunión, en el sistema se
                puede crear el acta de esta reunión, posteriormente descargarla
                para hacer firmar por los asistentes.
              </CheckModal>
            </div>

            <div class="form-row col-md-6 col-sm-12 pt-1">
              <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                <b-form-select v-on:change="changeItemStatus(itemStatus)"
                  :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                  class="selectpicker form-control" v-model="itemStatus">
                  <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                  <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                  <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                </b-form-select>
                <a :href="`/forms/copasst`" underline class="mx-1">
                  ¿Quién es el Comité del COPASST?
                </a>
              </b-form-group>
            </div>
          </div>
          <h5 class="pt-2">Designado del Empleador</h5>

          <form class="form-group" @submit.prevent="save">
            <div class="form-row pt-3">
              <b-form-group class="col-md-4 px-2" label="Fecha" label-for="date">
                <b-form-input :disabled="!allowAccess() || !getRole('Crear')" required type="date" id="date"
                  v-model="copassDate" placeholder=""></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-4 px-2" label="Nombre" label-for="nameEmployee">
                <b-form-select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
                  v-model="employee">
                  <b-form-select-option v-for="item in employees" :key="item.id" :value="item.id">
                    {{ item.full_name }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-md-4 px-2" label="Vigencia desde" label-for="vigDesde">
                <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="vigDesde" v-model="dateFrom"></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-4 px-2" label="Vigencia hasta" label-for="vigHasta">
                <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="vigHasta" v-model="dateTo"></b-form-input>
              </b-form-group>
            </div>

            <div class="form-group text-right mr-2">
              <button :disabled="submitted" type="submit" class="btn btn-primary mx-1 ml-2">
                Guardar
              </button>

              <button type="reset" class="btn btn-secondary mx-1" @click="employee = null">
                Cancelar
              </button>
            </div>

            <hr />

            <div class="row">
              <div class="col-lg-12">
                <div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Cargo Copasst</th>
                            <th class="text-center">Acta</th>
                            <th class="text-center">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in rows" :key="item.id">
                            <td class="text-center align-middle">
                              {{ dateConvert(item.date) }}
                            </td>
                            <td class="text-center align-middle">
                              {{ item.full_name || "-" }}
                            </td>
                            <td class="text-center align-middle">
                              {{ item.position }}
                            </td>
                            <td class="text-center align-middle">
                              <button type="button" v-if="item" :disabled="!allowAccess() || !getRole('Consultar')
                                " @click="downloadActa(item.id)" class="btn btn-outline-primary btn-md"
                                title="Descargar acta">
                                <i class="bx bx-download"></i>
                              </button>
                              <div class="mt-1">
                                <span v-if="item.workflow_status === 'signed'" class="badge badge-success">Firmada</span>
                                <span v-else class="badge badge-secondary">Borrador</span>
                              </div>
                            </td>
                            <td class="text-center align-middle">
                              <b-dropdown variant="primary" dropleft :disabled="!allowAccess() || !getRole('Editar')">
                                <template v-slot:button-content>
                                  <i class="mdi mdi-eye"></i>
                                </template>
                                <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                  " :href="item.id &&
                                    `/forms/estandares/${companyID}/acta-conformacion1.1.6/${item.id}`
                                    ">
                                  Editar
                                </b-dropdown-item>
                              </b-dropdown>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>
